import { render } from "./IsoVoyageEgypte.vue?vue&type=template&id=4828fca2"
import script from "./IsoVoyageEgypte.vue?vue&type=script&lang=js"
export * from "./IsoVoyageEgypte.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__